import {
  GET_USER_FILES,
  INPUT_FIELD_BG_COLOR,
  RESET_IMAGE_URL,
  RESET_PLAY,
  SAVE_USER_FILE,
  TOTAL_UPCOMING_MEETINGS,
  UPLOAD_FILE,
} from 'store/types'

const initialState = {
  uploadedImage: '',
  uploadFileLoading: false,
  userFiles: [],
  // Whose files userFiles holds, and whether loading them failed
  userFilesUserId: undefined as string | undefined,
  userFilesLoading: false,
  userFilesError: false,
  // Files panel uploads still running, by whose files they go to, and the last one saved
  userFilesUploading: {} as Record<string, number>,
  userFilesUploaded: null as { userId: string; ids: string[] } | null,
  uploadFileErrors: '',
  totalUpComingMeeting: 0,
  inputFieldBgColor: 'bg-grey-light',
  uploadedFile: [],
  // The id a caller gave the upload started last, and the one uploadedFile is the result of
  uploadFileRequestId: undefined as string | undefined,
  uploadedFileRequestId: undefined as string | undefined,
}

// The Files panel's uploads (they notify the owner of the files), counted per user
const isFilesPanelUpload = (action) => !!action.payload?.generationNotification
const countUploads = (state, userId: string, change: number) => ({
  ...state.userFilesUploading,
  [userId]: Math.max((state.userFilesUploading[userId] || 0) + change, 0),
})

function reducer(state = initialState, action) {
  switch (action.type) {
    case UPLOAD_FILE.STARTED:
      return {
        ...state,
        // uploadedImage: '',
        uploadFileErrors: '',
        uploadFileLoading: true,
        uploadFileRequestId: action.payload?.requestId,
      }
    case UPLOAD_FILE.FULLFILLED:
      return {
        ...state,
        uploadedFile: action.payload?.fileData || [],
        uploadFileLoading: false,
        uploadedFileRequestId: action.payload?.requestId,
      }
    case UPLOAD_FILE.REJECTED:
    case UPLOAD_FILE.RESET:
      return {
        ...state,
        uploadedFile: [],
        uploadFileErrors: '',
        uploadFileLoading: false,
      }

    case GET_USER_FILES.STARTED:
      return {
        ...state,
        userFiles: [],
        userFilesUserId: action.payload?.userId,
        userFilesLoading: true,
        userFilesError: false,
      }
    case GET_USER_FILES.FULLFILLED:
      // Only the list of the user asked for last: anyone else's is never shown as theirs
      if (action.payload?.userId !== state.userFilesUserId) return state
      return {
        ...state,
        userFiles: action.payload.files,
        userFilesLoading: false,
        userFilesError: false,
      }
    case GET_USER_FILES.REJECTED:
      if (action.payload?.userId !== state.userFilesUserId) return state
      return {
        ...state,
        userFilesLoading: false,
        userFilesError: true,
      }
    case TOTAL_UPCOMING_MEETINGS:
      return {
        ...state,
        totalUpComingMeeting: action.payload,
      }
    case RESET_IMAGE_URL:
      return {
        ...state,
        filesData: {},
      }
    case INPUT_FIELD_BG_COLOR:
      return {
        ...state,
        inputFieldBgColor: action.payload,
      }
    case RESET_PLAY:
      return {
        ...state,
        filesData: {},
      }

    case SAVE_USER_FILE.STARTED:
      if (!isFilesPanelUpload(action)) return state
      return {
        ...state,
        userFilesUploading: countUploads(state, action.payload.userId, 1),
      }
    case SAVE_USER_FILE.FULLFILLED:
    case SAVE_USER_FILE.REJECTED:
      if (!isFilesPanelUpload(action)) {
        return {
          ...state,
          uploadedFile: [],
        }
      }
      return {
        ...state,
        userFilesUploading: countUploads(state, action.payload.userId, -1),
        userFilesUploaded:
          action.type === SAVE_USER_FILE.FULLFILLED
            ? { userId: action.payload.userId, ids: action.payload.ids }
            : state.userFilesUploaded,
      }
    default:
  }
  return state
}

export default reducer
